import { render, staticRenderFns } from "./EntitlementDetail.vue?vue&type=template&id=7c8494e8&"
import script from "./EntitlementDetail.vue?vue&type=script&lang=js&"
export * from "./EntitlementDetail.vue?vue&type=script&lang=js&"
import style0 from "./EntitlementDetail.vue?vue&type=style&index=0&id=7c8494e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports